import { render, staticRenderFns } from "./GoogleReviewContent.vue?vue&type=template&id=836b29b4"
import script from "./GoogleReviewContent.vue?vue&type=script&lang=js"
export * from "./GoogleReviewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports